import React, { useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { ADMIN, ifyouApi } from 'apis/config';
import { adminUserApi } from 'apis/adminUserApis';
import FullLayout from 'components/layout/FullLayout';
import DefaultInput from 'components/input/DefaultInput';
import DefaultButton from 'components/button/DefaultButton';
/**
 * * 소속 조직 등록
 */

const OrganizationInputPage = () => {
  const [cookies, setCookie] = useCookies();
  const navigate = useNavigate();

  const [adminData, setAdminData] = useState({
    name: '',
    organization: '',
  });

  const handleChangeName = (e) => {
    let newData = e.target.value;
    setAdminData({ ...adminData, name: newData });
  };

  const handleChangeOrganization = (e) => {
    let newData = e.target.value;
    setAdminData({ ...adminData, organization: newData });
  };

  const handleReset = (text) => () => {
    if (text === 'name') {
      setAdminData({ ...adminData, name: '' });
    }
    if (text === 'organization') {
      setAdminData({ ...adminData, organization: '' });
    }
  };

  //조직(마지막input에서)
  const enter = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  // 시작하기 => 데이터 서버 전송
  const handleSubmit = async () => {
    const vaild = /^[ㄱ-ㅎ|가-힣|0-9|]+$/;
    if (!vaild.test(adminData.organization)) {
      message.error({
        content: '조직명은 한글 및 숫자만 입력 가능합니다.',
        duration: 0.6,
      });
      return false;
    }
    const response = await adminUserApi.updateInfo(
      cookies.loginAdmin.googleId,
      adminData,
    );
    await ifyouApi.post(`${ADMIN}/login`, {
      googleId: cookies.loginAdmin.googleId,
      name: adminData.name,
      email: cookies.loginAdmin.email,
    });
    if (response.code === 'OK') {
      alert(`정보 저장 완료. 다시 로그인 해주세요.`);
      setCookie('userName', adminData.name, { expires: 0 });
      navigate('/story');
    }
  };
  return (
    <FullLayout>
      <ContentBox>
        <table>
          <tbody>
            <tr>
              <th>
                <div>
                  <span>* </span>이름
                </div>
              </th>
              <td>
                <DefaultInput
                  onChange={handleChangeName}
                  value={adminData.name}
                  onClick={handleReset('name')}
                />
                <span>이름을 기입해주세요.</span>
              </td>
            </tr>
            <tr>
              <th>
                <div>
                  <span>* </span>조직
                </div>
              </th>
              <td>
                <DefaultInput
                  placeholder='영문, 특수문자 사용 불가 ex) 피어코퍼레이션'
                  onChange={handleChangeOrganization}
                  value={adminData.organization}
                  onClick={handleReset('organization')}
                  onKeyPress={enter}
                />
                <span>정확한 조직명을 입력해주세요.</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <DefaultButton onClick={handleSubmit}>시작하기</DefaultButton>
        </div>
      </ContentBox>
    </FullLayout>
  );
};

export default OrganizationInputPage;

const ContentBox = styled.div`
  margin-top: 20px;
  table {
    background-color: #fff;
    width: 90%;
    margin: 0 auto;
    tr,
    th,
    td {
      border: 10px solid #fff;
    }

    th {
      width: 4rem;
      height: 6rem;
      font-weight: 900;
    }
    th > div {
      /* background-color: brown; */
      margin-top: -15px;
      font-weight: 900;
    }
    th > div > span {
      font-size: 14px;
    }
    td {
      width: 20rem;
    }
    span {
      color: ${theme.colors.warnnigText};
      font-weight: 600;
      font-size: 11.8px;
    }
  }
  > div {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
`;
